export const debounce = <R extends any[], T extends (...args: R) => any>(fn: T, wait = 1000) => {
  let timeout: NodeJS.Timeout | null = null;

  return (...args: R) => {
    clearTimeout(timeout!);
    timeout = setTimeout(() => fn(...args), wait);
  };
};
